// Author Liang Gang Qiang
// Date 2021-11-10 09:23:07

import * as model from "@/model/mintalMes/quality/MintalMesQualityCompoundModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesQualityCompound(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_QUALITY_URL,
    })
    .buildStore()
